import { render, staticRenderFns } from "./SignUpFix.vue?vue&type=template&id=496b1381&scoped=true"
import script from "./SignUpFix.vue?vue&type=script&lang=js"
export * from "./SignUpFix.vue?vue&type=script&lang=js"
import style0 from "./SignUpFix.vue?vue&type=style&index=0&id=496b1381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b1381",
  null
  
)

export default component.exports